import { loadUnreadNotifications } from '../notifications';
import { refreshNexlaAccessToken, logout } from '../session';
import {
  SESSION_REFRESH_THRESHOLD_MS,
  AVERAGE_AUTH_RESPONSE_TIME,
} from '../../constants/utilityConstants';
import { getCurrentUser, getOriginalAccessToken } from '../../reducers/selectors';
import { getAllTags } from '../tags';

import { loadVendors } from '../vendors';
import { getUserSettings } from '../users';
import { fetchCurrentOrg } from '../orgs';

let timer = null;
let notificationTimer = null;

const notificationTickTimerFired = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      app: { activeViews },
    } = state;

    const currentUser = getCurrentUser(state);
    if (!currentUser) {
      //return if user not logged-in
      return;
    }

    if (
      activeViews &&
      activeViews.notificationsListOpen === false &&
      activeViews.formViewOpen === false
    ) {
      dispatch(loadUnreadNotifications());
    }
  };
};

const appTickTimerFired = (isInitialFire = false) => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      app: { activeViews },
      session: { expiresAt, isGoogleUser },
    } = state;

    const currentUser = getCurrentUser(state);
    if (!currentUser) {
      //return if user not logged-in
      return;
    }

    //TODO: Call for refreshing token if due to expire
    const accessToken = getOriginalAccessToken(state);

    if (accessToken && expiresAt) {
      let now = Date.now();
      if (expiresAt <= now + AVERAGE_AUTH_RESPONSE_TIME) {
        //logout if the session is already expired, or going to expire before the expected time for refresh response
        return dispatch(logout());
      } else if (expiresAt - now < SESSION_REFRESH_THRESHOLD_MS) {
        //refresh session 5 ticks (15 minutes) before it expires.
        dispatch(refreshNexlaAccessToken(accessToken, isGoogleUser));
      }

      if (isInitialFire === true) {
        // we only want to fetch this once on page load
        //TODO: NEX-13948: Temp hack for fetching org. We need it to know features enabled for the org
        dispatch(fetchCurrentOrg());
        dispatch(getUserSettings(true));
      }
    } else {
      dispatch(logout());
    }

    dispatch(loadVendors());
    dispatch(getAllTags(false));

    if (
      activeViews &&
      activeViews.notificationsListOpen === false &&
      activeViews.formViewOpen === false
    ) {
      dispatch(loadUnreadNotifications());
    }
  };
};

export const setAppTickTimer = (tickMs) => {
  return (dispatch) => {
    dispatch(appTickTimerFired(true));
    timer = setInterval(() => {
      dispatch(appTickTimerFired());
    }, tickMs);
  };
};

export const fireNotificationTimer = (tickMs) => {
  return (dispatch) => {
    dispatch(notificationTickTimerFired());
    notificationTimer = setInterval(() => {
      dispatch(notificationTickTimerFired);
    }, tickMs);
  };
};

export const clearNotificationTimer = () => {
  return () => {
    if (notificationTimer) {
      clearInterval(notificationTimer);
      notificationTimer = null;
    }
  };
};

export const clearAppTickTimer = () => {
  return () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };
};
